<template>
  <v-card>
    <v-card-title>
      Subscriptions
      <v-spacer></v-spacer>
      <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
    </v-card-title>
    <v-data-table :headers="user.isAdmin== true ? headers : editorHeaders" :items="fundis" :search="search" :pagination.sync="pagination" :rows-per-page-items="listSize">
      <template v-slot:items="props">
        <td v-if="props.item.userId">{{ props.item.userId.firstName }}</td>
        <td v-if="props.item.userId">{{ props.item.userId.lastName }}</td>
        <td v-if="props.item.userId">{{ props.item.userId.countryCode }}{{ props.item.userId.phone }}</td>
        <td v-if="props.item.userId">{{ props.item.userId.email }}</td>
        <td v-if="props.item.userId && props.item.userId.active==true" style="color: green; font-weight: bold">Active</td>
        <td v-else style="color: red; font-weight: bold">In Active</td>
        <td>
          <span
            v-if="props.item.userId !== null && props.item.userId.expired==false"
            style="color: blue; font-weight: bold"
          >Subscribed</span>
          <span v-if="props.item.userId !== null && props.item.userId.expired==true" style="color:red; font-weight: bold">Expired</span>
        </td>
        <td v-if="props.item.userId !== null && props.item.userId.locationOne">{{ props.item.userId.locationOne.locationName }}</td>
        <td v-else></td>
        <td>{{ props.item.packageName }}</td>
        <td>{{ props.item.packageOption }}</td>
        <td class>{{ props.item.endsAt | moment("Do MMM YYYY")  }}</td>
        <td class v-if="user.isAdmin== true">
          <v-btn icon @click="deleteModal(props.item)">
            <v-icon color="red">delete</v-icon>
          </v-btn>
        </td>
      </template>
      <v-alert
        v-slot:no-results
        :value="true"
        color="error"
        icon="warning"
      >Your search for "{{ search }}" found no results.</v-alert>
    </v-data-table>

      <!-- delete dialog -->
      <v-dialog v-model="delete_dialog" max-width="750px">
        <v-toolbar class="red" dark dense>
          <v-toolbar-title>Delete Subscription</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="delete_dialog=false">
            <v-icon>clear</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card>
          <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 class="pa-2">
                  <h5>Are you sure you want to delete this subscription?</h5>
                </v-flex>

                <v-flex xs6 sm6 v-if="dataItem.userId">
                  <v-text-field label="First Name" v-model="dataItem.userId.firstName"></v-text-field>
                </v-flex>

                <v-flex xs6 sm6 v-if="dataItem.userId">
                  <v-text-field label="Last Name" v-model="dataItem.userId.lastName"></v-text-field>
                </v-flex>

                <v-flex xs6 sm6 v-if="dataItem.userId">
                  <v-text-field label="Phone" v-model="dataItem.userId.phone"></v-text-field>
                </v-flex>

                <v-flex xs6 sm6 v-if="dataItem.userId">
                  <v-text-field label="Email" v-model="dataItem.userId.email"></v-text-field>
                </v-flex>

                <v-flex xs12>
                  <v-btn color="red" class="right" small dark @click="deleteSubscription" :loading="loader">
                    <v-icon left>delete</v-icon>Yes
                  </v-btn>
                </v-flex>
            </v-layout>
          </v-container>
        </v-card>
        </v-dialog>
      <!-- end of delete  -->
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["user"])
  },
  props: {
    fundis: {
      type: Array,
      default: [],
      required: true
    }
  },
  data() {
    return {
      search: "",
      delete_dialog: false,
      activate_dialog: false,
      deactivate_dialog: false,
      pagination: {
        rowsPerPage: 10
      },
      dataItem: {},
      loader: false,
      headers: [
        {
          text: "First Name",
          align: "left",
          sortable: false,
          value: "expert.firstName"
        },
        { text: "Last Name", value: "expert.lastName" },
        { text: "Phone", value: "expert.phone" },
        { text: "Email", value: "expert.email" },
        { text: "Status", value: "expert.email" },
        { text: "Expiry", value: "expert.expired" },
        { text: "Location", value: "expert.location" },
        { text: "Package Name", value: "packageName" },
        { text: "Option", value: "packageOption" },
        { text: "Expiry Date", value: "endsAt" },
        { text: "Action", value: "action" }
      ],
      editorHeaders: [
        {
          text: "First Name",
          align: "left",
          sortable: false,
          value: "expert.firstName"
        },
        { text: "Last Name", value: "expert.lastName" },
        { text: "Phone", value: "expert.phone" },
        { text: "Email", value: "expert.email" },
        { text: "Status", value: "expert.email" },
        { text: "Expiry", value: "expert.expired" },
        { text: "Location", value: "expert.location" },
        { text: "Package Name", value: "packageName" },
        { text: "Option", value: "packageOption" },
        { text: "Expiry Date", value: "endsAt" }
      ],
      listSize: [5,10,25,50,100,{"text":"$vuetify.dataIterator.rowsPerPageAll","value":-1}],
    };
  },
  methods: {
    deleteModal(item) {
      this.dataItem = Object.assign({}, item);
      this.delete_dialog = true;
    },
    deleteSubscription() {
      this.loader = true;
      const data = this.dataItem;
      const self = this;
      const res = this.$store
        .dispatch("remove", "/subscription/"+data._id)
        .then(res => {
          if (res.state) {
            self.loader = false;
            location.reload();
          }
        })
        .finally(() => {});
    }
  }
};
</script>